import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import LanguageToggle from "../components/LanguageToggle";
import { BrandMark } from "../components/Logo";

export default function Signup() {
  const { t } = useI18n();
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", name: "", company_name: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const r = await signup(form);
    setBusy(false);
    if (!r.ok) { setErr(r.error); return; }
    navigate("/app/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center grain relative px-4">
      <div className="absolute top-6 right-6 z-10"><LanguageToggle /></div>
      <Link to="/" className="absolute top-6 left-6 z-10" data-testid="brand-link">
        <BrandMark />
      </Link>
      <div className="w-full max-w-md glass rounded-3xl p-8 lg:p-10 anim-stagger relative">
        <h1 className="text-3xl font-extrabold text-white tracking-tight">{t("auth.signup_title")}</h1>
        <p className="mt-2 text-sm text-slate-400">{t("auth.signup_sub")}</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.company")}</label>
            <input data-testid="signup-company" required value={form.company_name} onChange={onChange("company_name")} className="input-dark mt-1.5" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.name")}</label>
            <input data-testid="signup-name" required value={form.name} onChange={onChange("name")} className="input-dark mt-1.5" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.email")}</label>
            <input data-testid="signup-email" type="email" required value={form.email} onChange={onChange("email")} className="input-dark mt-1.5" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.password")}</label>
            <input data-testid="signup-password" type="password" required minLength={6} value={form.password} onChange={onChange("password")} className="input-dark mt-1.5" />
          </div>
          {err && <div className="text-rose-400 text-sm" data-testid="signup-error">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="signup-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            {t("auth.submit_signup")}
          </button>
        </form>
        <p className="mt-6 text-sm text-slate-400 text-center">
          {t("auth.have_account")}{" "}
          <Link to="/login" className="text-magenta hover:text-primary-hover font-semibold" data-testid="go-login">{t("auth.go_login")}</Link>
        </p>
      </div>
    </div>
  );
}
